import { render, staticRenderFns } from "./UserAgreementEn.vue?vue&type=template&id=42650048&scoped=true"
import script from "./UserAgreementEn.vue?vue&type=script&lang=js"
export * from "./UserAgreementEn.vue?vue&type=script&lang=js"
import style0 from "./UserAgreementEn.vue?vue&type=style&index=0&id=42650048&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42650048",
  null
  
)

export default component.exports